// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"feed-module--wrapper--1CXQF","container":"feed-module--container--DFVMu","inner":"feed-module--inner--1EC-h"};